import type { Company } from '@mss_creator/shared';
import { ActionMenu, Button } from '@pms-digital/design-system';

export interface CompanyActionsMenuProps {
  company: Pick<Company, 'id' | 'name'>;
  onArchive: (company: Pick<Company, 'id' | 'name'>) => void;
}

/**
 * The « ⋯ » menu of a company card (issue #20, planche 01). Its one entry,
 * « Archiver », is in the normal style and not red: archiving is reversible.
 * Only offered to pms_user and pms_admin, by the caller — the API refuses the
 * others (403).
 */
export function CompanyActionsMenu({ company, onArchive }: CompanyActionsMenuProps) {
  return (
    <ActionMenu
      align="end"
      trigger={
        <Button
          type="button"
          variant="ghost"
          size="icon"
          icon="more_horiz"
          aria-label={`Actions pour « ${company.name} »`}
        />
      }
      items={[{ label: 'Archiver', icon: 'archive', onSelect: () => onArchive(company) }]}
    />
  );
}
